<template>
  <div class="option-setting">
    <el-select
      v-model="control.optionType"
      placeholder=""
      :disabled="!control._isNew"
      @change="changeOptionSet"
    >
      <el-option label="自定义" value="自定义"></el-option>
      <el-option label="选项集" value="选项集"></el-option>
      <el-option label="动态数据源" value="动态数据源"></el-option>
    </el-select>

    <div v-if="control.optionType === '自定义'">
      <div v-if="control._type === 'option'">
        <span style="padding: 0 5px">颜色</span>
        <el-switch :value="useColor" class="switchStyle" @change="switchColorState"></el-switch>
        <el-button style="float: right" type="text" @click="turnToOptionsSet">
          转为选项集
        </el-button>
      </div>
      <draggable
        class="option-setting"
        handle=".el-input-group__prepend"
        v-model="control.options"
        :animation="50"
      >
        <div v-for="(option, i) in control.options" :key="i">
          <el-input v-model="option.label" @input="option.value = option.label">
            <i class="el-icon-rank" slot="prepend"></i>
            <div slot="append" style="display: flex; line-height: 5px">
              <el-popover v-if="useColor" placement="top" v-model="option.visible">
                <div style="text-align: right; margin: 0">
                  <el-button
                    v-for="(item, index) in colorList"
                    :key="index"
                    :class="item"
                    size="mini"
                    circle
                    @click="close(i, item)"
                  ></el-button>
                </div>
                <el-button
                  slot="reference"
                  :class="option.color"
                  size="mini"
                  style="margin-left: 1px; margin-right: 15px; border: 0"
                  circle
                ></el-button>
              </el-popover>
              <template v-if="control.oneFlag">
                <el-tooltip effect="dark" content="设为默认" placement="top">
                  <el-radio
                    :value="_.get(control, 'defaultVal.[0]')"
                    :label="option.value"
                    @input="control.defaultVal = [option.value]"
                    style="margin-right: 15px"
                  ></el-radio>
                </el-tooltip>
              </template>
              <template v-else>
                <el-tooltip effect="dark" content="设为默认" placement="top">
                  <el-radio
                    v-model="option.isDefault"
                    :label="option.value"
                    @change="setOptionDefaultVal()"
                    style="margin-right: 15px"
                  ></el-radio>
                </el-tooltip>
              </template>
              <i
                class="el-icon-delete"
                @click="deleteOption(i)"
                style="float: right; cursor: pointer"
              ></i>
            </div>
          </el-input>
        </div>
        <template slot="footer">
          <div>
            <el-button type="success" size="mini" icon="el-icon-plus" round @click="addOptions">
              增加选项
            </el-button>
            <el-button
              v-if="!_.isEmpty(control.defaultVal)"
              type="danger"
              size="mini"
              icon="el-icon-close"
              round
              @click="clearDefaultVal"
            >
              清除默认值
            </el-button>
          </div>
        </template>
      </draggable>
    </div>
    <div v-else-if="control.optionType === '选项集'">
      <el-card class="card-setting" shadow="never">
        <div slot="header">
          <span>{{ optionsSet.name }}</span>
          <div style="float: right;">
            <el-button type="text" @click="$refs.optionSetDialog.open()">
              编辑
            </el-button>
            <el-button type="text" @click="$refs.optionSetListDialog.open()">
              重新选择
            </el-button>
          </div>
        </div>
        <div v-for="(option, i) in control.options" :key="i">
          <div style="display: flex;padding: 5px 0;">
            <div
              v-if="option.color"
              :class="option.color"
              style="width: 15px; height: 15px; border-radius: 50%; margin-right: 10px"
            ></div>
            <template v-if="control.oneFlag">
              <el-tooltip effect="dark" content="设为默认" placement="top">
                <el-radio
                  :value="_.get(control, 'defaultVal.[0]')"
                  :label="option.value"
                  @input="control.defaultVal = [option.value]"
                  style="margin-right: 15px;max-width: 228px;"
                ></el-radio>
              </el-tooltip>
            </template>
            <template v-else>
              <el-tooltip effect="dark" content="设为默认" placement="top">
                <el-radio
                  v-model="option.isDefault"
                  :label="option.value"
                  @change="setOptionDefaultVal()"
                  style="margin-right: 15px;max-width: 228px;"
                ></el-radio>
              </el-tooltip>
            </template>
          </div>
        </div>
      </el-card>
      <el-button
        v-if="!_.isEmpty(control.defaultVal)"
        type="danger"
        size="mini"
        icon="el-icon-close"
        :round="true"
        @click="clearDefaultVal"
      >
        清除默认值
      </el-button>
    </div>
    <div v-else-if="control.optionType === '动态数据源'" class="dynamic-data-source">
      <group-select
        placeholder="请选择工作表"
        :grouped-options="sheetGroups"
        v-model="control.refSources.sheetId"
      ></group-select>
      <template v-if="control.refSources.sheetId">
        <el-select placeholder="请选择字段" v-model="control.refSources.cid" style="width: 100%;">
          <el-option
            v-for="c in filterableControls"
            :key="c._cid"
            :label="c.name"
            :value="c._cid"
          ></el-option>
        </el-select>
        <el-button type="text" @click="sheetFilterVisible = true">
          筛选
        </el-button>
      </template>
    </div>
    <option-set-dialog
      ref="optionSetDialog"
      :optionSetId="optionSetId"
      :appId="appId"
      @submit="closeOuterDialog"
    ></option-set-dialog>
    <option-set-list-dialog
      ref="optionSetListDialog"
      :appId="appId"
      @submit="closeInnerDialog"
    ></option-set-list-dialog>
    <sheet-filter
      v-if="control.optionType === '动态数据源'"
      @submit="setRefCondition"
      :dialog-visible.sync="sheetFilterVisible"
      :search-sheet="refSourceSheet"
      :rely-sheet-info="availableSheetMap[sheetId]"
      :condition-list="control.refSources.filters"
      from="sheet_backend"
    ></sheet-filter>
  </div>
</template>

<script>
import draggable from "vuedraggable"
import OptionSetListDialog from "./optionSetList-dialog.vue"
import OptionSetDialog from "./optionSet-dialog.vue"
import GroupSelect from "@/components/UIComponents/GroupSelect"
import SheetFilter from "@/components/UIComponents/SheetFilter"
import { createOptionSet, getOptionSet } from "@/api/sheet/sheetOptionSet"
import { colorList, defaultOptions } from "./static"

export default {
  name: "option-setting",
  props: {
    control: Object,
    sheetId: String,
    appId: String,
    availableSheets: Array,
    availableSheetMap: Object
  },
  components: { draggable, OptionSetListDialog, OptionSetDialog, GroupSelect, SheetFilter },
  computed: {
    optionSetId() {
      if (!this.control) return ""
      return this.control.setId || ""
    },
    useColor() {
      return Boolean(this.control.options?.[0]?.color)
    },
    sheetGroups() {
      return this.availableSheets
        .map((app, index) => {
          return {
            label: index === 0 ? app.name + " [当前应用]" : app.name + " [共享应用]",
            options: app.sheets
              .filter(sheet => sheet.sheetId !== this.sheetId)
              .map(sheet => {
                return {
                  label: sheet.name,
                  value: sheet.sheetId
                }
              })
          }
        })
        .filter(app => app.options.length)
    },
    refSourceSheet() {
      return this.availableSheetMap[this.control.refSources?.sheetId] || { controls: [] }
    },
    filterableControls() {
      return this.refSourceSheet.controls.filter(
        c => c._dataType === "string" || c._type === "option"
      )
    }
  },
  watch: {
    "control.setId": {
      immediate: true,
      handler() {
        if (this.control.optionType !== "选项集") return
        if (!this.control.setId) {
          this.optionsSet = {}
        } else {
          getOptionSet(this.control.setId).then(optionSet => {
            this.optionsSet = optionSet
            this.control.options = optionSet.options
          })
        }
      }
    },
    control: {
      immediate: true,
      handler() {
        let defaultVal = [].concat(this.control.defaultVal)
        this.control.options.forEach(option => {
          this.$set(option, "isDefault", defaultVal.includes(option.value) ? option.value : "")
        })
      }
    }
  },
  data() {
    return {
      optionsSet: {},
      sheetFilterVisible: false,
      colorList
    }
  },
  methods: {
    changeOptionSet() {
      switch (this.control.optionType) {
        case "自定义":
          this.control.setId = ""
          this.control.options = defaultOptions
          break
        case "选项集":
          this.$refs.optionSetListDialog.open()
          break
        case "动态数据源":
          this.control.allowAdd = false
          this.control.linkage = null
          this.$set(this.control, "refSources", {
            sheetId: null,
            cid: null,
            filters: []
          })
          break
      }
    },
    closeInnerDialog(selectedOptionSet) {
      if (selectedOptionSet) {
        this.$set(this.control, "setId", selectedOptionSet.id)
      } else {
        // 如果没选择选项集,则切换回自定义状态
        this.control.optionType = "自定义"
        this.changeOptionSet()
      }
    },
    // 设置 option 控件（多选）的默认值
    setOptionDefaultVal() {
      this.control.defaultVal = this.control.options.map(option => option.isDefault).filter(t => t)
    },
    clearDefaultVal() {
      this.control.defaultVal = []
      this.control.options.forEach(option => (option.isDefault = ""))
    },
    switchColorState() {
      let userColor = this.useColor
      this.control.options.forEach((option, idx) => {
        this.$set(option, "color", userColor ? null : this.colorList[idx % 5])
      })
    },
    close(i, color) {
      let control = this.control
      control.options[i].color = color
      control.options[i].visible = false
    },
    // 添加选项
    addOptions() {
      let label = "选项" + (this.control.options.length + 1)
      this.control.options.push({
        label,
        value: label,
        color: this.useColor ? this.colorList[this.control.options.length % 6] : null
      })
    },
    deleteOption(i) {
      let control = this.control
      if (control.options.length <= 1) return
      this.control.options.splice(i, 1)
      if (this.isLimitNum && control.countLimit[1] > control.options.length) {
        if (control.countLimit[0] > control.options.length) {
          this.$set(control, "countLimit", [control.options.length, control.options.length])
        } else {
          this.$set(control, "countLimit", [control.countLimit[0], control.options.length])
        }
      }
    },
    turnToOptionsSet() {
      this.$confirm(
        "转为选项集后，可以使选项在其他工作表中共用。此过程不可逆，转换后无法再恢复为自定义选项",
        "转为选项集",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        createOptionSet(
          {
            name: this.control.name,
            options: this.control.options
          },
          this.appId
        ).then(optionSet => {
          this.$set(this.control, "setId", optionSet.id)
          this.control.optionType = "选项集"
          this.$message.success("转换成功!")
        })
      })
    },
    closeOuterDialog(data) {
      this.control.options = data
    },
    setRefCondition(filters) {
      this.control.refSources.filters = filters
    }
  }
}
</script>

<style scoped lang="scss">
.option-setting {
  .card-setting {
    ::v-deep.el-card__header {
      padding: 0 20px;
    }
    ::v-deep.el-card__body {
      padding: 8px 18px;
    }
  }
  .dynamic-data-source {
    display: flex;
    flex-flow: column;
    align-items: flex-start;
  }
}
</style>
